import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import { ReversedGradientBorder } from '../commons'
import Button from '../Button/'
import Link from '../Link'

const AboutTeam = ({
  title,
  subtitle,
  components,
  images,
  ctaText,
  ctaUrl,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <div className="wrapper">
          <ReversedGradientBorder
            className={styles.gradBorder}
            height="3px"
          ></ReversedGradientBorder>
          <div className={`${styles.section} ${styles.titleSection}`}>
            <h2>{title}</h2>
          </div>
          <div className={`${styles.section} ${styles.aboutSection}`}>
            <div className={styles.description}>
              {subtitle.subtitle.split('\n').map((text, idx) => (
                <div key={idx}>{text}</div>
              ))}
            </div>
            <Link to={ctaUrl}>
              <Button className={styles.careersButton} inverted>
                {ctaText}
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.imageBox}>
        <GatsbyImage
          image={images[0].gatsbyImageData}
          style={{ height: '100%', width: '100%' }}
          alt={images[0]?.description}
        />
      </div>
    </div>
  )
}

export default AboutTeam
